import { killshotApi } from '../../api';

const NOTES_RECEIVED = 'NOTES_RECEIVED';
const NOTE_CREATE_MODAL_OPEN = 'NOTE_CREATE_MODAL_OPEN';
const NOTE_EDIT_MODAL_OPEN = 'NOTE_EDIT_MODAL_OPEN';
const NOTES_LOADING = 'NOTES_LOADING';

// GET All notes
export const notesReceived = notes => ({ type: NOTES_RECEIVED, payload: notes });

// Modals
export const noteCreateModalOpen = bool => ({ type: NOTE_CREATE_MODAL_OPEN, payload: bool });
export const noteEditModalOpen = bool => ({ type: NOTE_EDIT_MODAL_OPEN, payload: bool });

// Loaders
export const notesLoading = bool => ({ type: NOTES_LOADING, payload: bool });

export async function fetchNotesApi(entityType, entityID) {
  try {
    const response = await killshotApi.get(`v1/notes/${entityType}_${entityID}`, {});

    return response.notes;
  } catch (e) {
    throw e;
  }
}
